import './utils/setup-window.ts';
import './utils/setup-sentry.ts';
import './utils/setup-amplitude.ts';
import './utils/setup-auth.ts';
import './utils/setup-aws.ts';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import { Query } from '@tanstack/react-query';
import { theme } from './constants/theme/theme.tsx';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { DialogsProvider } from './contexts/Dialog/DialogProvider.tsx';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { routes } from './constants/routes.tsx';
import { persister, queryClient } from './constants/tanstack-query.ts';
import * as Sentry from '@sentry/react';
import './index.css';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter(routes);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
          persister: persister,
          dehydrateOptions: {
            // This allows us to set meta: { persist: true }, in a query to persist to local storage.
            // See useGetSearchCount for example.
            shouldDehydrateQuery: (query: Query) => {
              return query.meta?.persist === true;
            },
          },
        }}
      >
        <ReactQueryDevtools buttonPosition="bottom-left" />
        <DialogsProvider>
          <RouterProvider router={router} />
        </DialogsProvider>
      </PersistQueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);
